var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LocationMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.003 16c-.601 0-1.141-.31-1.441-.83L1.01 9.49a6.192 6.192 0 01-.971-4.06 6.13 6.13 0 011.85-3.76A5.887 5.887 0 016.384.01c3.082.22 5.493 2.74 5.613 5.86.05 1.32-.31 2.58-1.03 3.65L7.424 15.2c-.131.22-.321.41-.541.55-.29.17-.58.25-.88.25zm0-14.01c-1.021 0-1.982.39-2.722 1.11-.7.67-1.141 1.57-1.251 2.54a4.096 4.096 0 00.69 2.78l3.303 5.28 3.262-5.23s.03-.05.05-.07c.48-.72.72-1.56.69-2.45-.08-2.1-1.701-3.79-3.752-3.94h-.25l-.02-.02zm0 6.51A2.502 2.502 0 013.5 6a2.502 2.502 0 015.003 0c0 1.38-1.12 2.5-2.501 2.5zm0-3c-.28 0-.501.22-.501.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMini);
export default __webpack_public_path__ + "static/media/LocationMini.4602625ce3aee25eeef98eced8ac63dd.svg";
export { ForwardRef as ReactComponent };